import moment from 'moment';
import CalendarService from '@/api/CalendarService';

const state = {
  calendarDates: [],
};

const getters = {
  getFormattedCalendar: (state, getters) => (year, month) => {
    const firstDay = moment({ y: year, M: month, d: 1 });
    const lastDay = moment({ y: year, M: month, d: firstDay.daysInMonth() });
    const calendar = {
      header: [
        moment.weekdays(0),
        moment.weekdays(1),
        moment.weekdays(2),
        moment.weekdays(3),
        moment.weekdays(4),
        moment.weekdays(5),
        moment.weekdays(6),
      ],
      firstDay,
      weeks: [],
    };

    let week = [];
    // Fill blank begining
    for (let i = 0; i < firstDay.day(); i += 1) {
      week.push({ date: null, items: [] });
    }
    // Push weeks
    for (let j = 0; j < firstDay.daysInMonth(); j += 1) {
      const currentDate = moment(firstDay).add(j, 'day');
      week.push(getters.getCalendarDateSummary(currentDate));
      if (currentDate.day() === 6) {
        calendar.weeks.push(week);
        week = [];
      }
    }
    // Fill blank ending
    for (let k = 0; k < 6 - lastDay.day(); k += 1) {
      week.push({ date: null, items: [] });
    }
    // Push the last week
    calendar.weeks.push(week);

    return calendar;
  },
  getCalendarDateSummary: state => (date) => {
    const mDate = moment(date);
    let calendardate = {
      date: mDate,
      dateSummary: null,
    };
    if (state.calendarDates) {
      state.calendarDates.forEach((element) => {
        if (
          moment(element.date).format('YYYY-MM-DD')
          === mDate.format('YYYY-MM-DD')
        ) {
          calendardate = {
            date: mDate,
            dateSummary: element,
          };
        }
      });
    }
    return calendardate;
  },
  isPastDay: () => (d) => {
    const day = moment({
      y: moment(d).year(),
      M: moment(d).month(),
      d: moment(d).date(),
      h: 0,
      m: 0,
      s: 0,
      ms: 0,
    });
    const currentDay = moment({
      y: moment().year(),
      M: moment().month(),
      d: moment().date(),
      h: 0,
      m: 0,
      s: 0,
      ms: 0,
    });

    return day < currentDay;
  },
  isPastWeek: () => (d) => {
    const week = moment(d).week();
    const year = moment(d).year();
    const currentWeek = moment().week();
    const currentYear = moment().year();

    return year < currentYear || (year === currentYear && week < currentWeek);
  },
  isWorkDay: () => (date) => {
    let isWorkDay = false;
    if (date.date) {
      const mDate = moment(date.date);
      if (mDate.day() !== 0 && mDate.day() !== 6) {
        isWorkDay = true;
        if (date.dateSummary && date.dateSummary.calendarItems) {
          date.dateSummary.calendarItems.forEach((item) => {
            if (
              item.type === 'NON_WORKING_DAY.STATUTORY_HOLIDAY'
              || item.type === 'NON_WORKING_DAY.HOLIDAY'
            ) {
              isWorkDay = false;
            }
          });
        }
      }
    }
    return isWorkDay;
  },
  hasItems: () => (day) => {
    let has = false;
    if (day && day.dateSummary) {
      if (
        day.dateSummary.calendarItems
        && day.dateSummary.calendarItems.length > 0
      ) {
        has = true;
      }
    }
    return has;
  },
  hasTimeEntered: () => (day) => {
    let has = false;
    if (day && day.dateSummary) {
      if (day.dateSummary.hasTime) {
        has = true;
      }
    }
    return has;
  },
  hasTimeNotSubmitted: (state, getters) => (day) => {
    let has = false;
    if (day && day.dateSummary) {
      if (day.dateSummary.hasUnsubmittedTime && getters.isPastWeek(day.date)) {
        has = true;
      }
    }
    return has;
  },
  hasNoTimeEntered: (state, getters) => (day) => {
    let has = false;
    if (day && day.date) {
      if (getters.isWorkDay(day) && getters.isPastDay(day.date)) {
        has = true;
        if (day.dateSummary && day.dateSummary.hasTime) {
          has = false;
        }
      }
    }
    return has;
  },
};

const actions = {
  getCalendarSummary({ commit }, args) {
    return CalendarService.getCalendarSummary(args).then((response) => {
      commit('calendarDates', response.data);
    });
  },
};

const mutations = {
  calendarDates(state, payload) {
    state.calendarDates = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
